const types = {
    SAVE_SEARCHPARAMS: 'rank/SAVE_SEARCHPARAMS',
};

export const saveSearchParams = params => ({
    type: types.SAVE_SEARCHPARAMS,
    params,
});

const initState = {
    params: {},
};

const rankReducer = (state = initState, actions) => {
    switch(actions.type) {
        case types.SAVE_SEARCHPARAMS:
            return { params: { ...actions.params } };
        default:
            return state;
    }
}

export default rankReducer;


// WEBPACK FOOTER //
// ./src/actions/rankActions.js